<template>
  <!--  organization-->
  <div class="organization">
    <!--    外层-->
    <div v-if="out_box">
      <!--      组织模块-->
      <div v-if="out">
        <div style="text-align: right" v-if="admin == 0">
          <div class="inbox_box" @click="openInboxHandle">Inbox ({{ inbox_num }})</div>
          <el-button type="success" round style="cursor: pointer" @click="InviteHandle">Invite</el-button>
          <el-button type="primary" round style="margin-right: 16px"
                     @click="addNewOraDiog = true;">NEW
          </el-button>
        </div>
        <div class="tabel" v-loading="oraLoading">
          <el-table
            v-if="organData.length!=0"
            :data="organData"
            style="width: 100%;font-weight: normal"
          >
            <el-table-column
              header-align="left"
              align="left"
              prop="organization_name"
              label="Organization"
              width="280px"
              class-name="changePadding"
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  style="font-weight: normal"
                  @click="changeTable(scope.row)"
                >{{ scope.row.organization_name }}
                </el-button>
              </template>
            </el-table-column>
            <el-table-column
              prop="count"
              label="Number of sub stores"
            >
            </el-table-column>
            <el-table-column
              label="Actions"
              width="130px"
            >
              <template slot-scope="scope">
                <div class="action">
              <span @click="handleDetial(scope.$index, scope.row)">
                <img src="../assets/organization/detail.png" alt="">
              </span>
                  <span @click="handleEdit(scope.$index, scope.row)" v-if="admin == 0">
                    <img src="../assets/image/edit@2x.png" alt="">
                  </span>
                  <span @click="handleDelete(scope.$index, scope.row)" v-if="admin == 0">
              <img src="../assets/image/delete@2x.png" alt="">
              </span>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div v-else class="empty">
            <div>
              <img src="../assets/image/list_blank.png" alt="">
              <h2 style="color: #CCCCCC;font-size: 16px">No items found</h2>
            </div>
          </div>
        </div>
        <div class="btomPagin">
          <div class="innerLeft">{{ outPage }} - <span>{{ organData.length }}</span> of <span>{{ outTotal }}</span> items</div>
          <div>
            <el-pagination
              :page-size="10"
              layout="prev, pager, next, jumper"
              :current-page="outPage"
              :total="outTotal"
              @current-change="handleOrgCurrentChange"
            >
            </el-pagination>
          </div>
        </div>
      </div>
      <!--      店铺模块-->
      <div v-if="!out">
        <div style="display: flex;justify-content: space-between">
          <div class="backBox">
            <div class="innerLeft" @click="out = true;getListData()">
              <i class="el-icon-arrow-left"></i>Back
            </div>
            <div style="color:#E95646">
              {{ this.innerTitle }}
            </div>
          </div>
          <div>
            <el-button type="primary" round style="margin-right: 16px;background: #FFB94C;border: #FFB94C"
                       @click="addSubHandle">NEW
            </el-button>
          </div>
        </div>
        <div class="innerTabel">
          <div class="tabel" v-loading="storeLoading">
            <el-table
              v-if="innerTabel.length!=0"
              :data="innerTabel"
              style="width: 100%;font-weight: normal"
            >
              <el-table-column
                header-align="center"
                align="center"
                prop="store_name"
                label="Sub Store"
                width="250px"
              >
              </el-table-column>
              <el-table-column
                prop="username"
                label="Username"
              >
              </el-table-column>

<!--              <el-table-column-->
<!--                prop="group_name"-->
<!--                label="Driver Group"-->
<!--              >-->
<!--              </el-table-column>-->

              <el-table-column
                prop="suffix"
                label="Suffix"
              >
              </el-table-column>
              <el-table-column
                label="Actions"
                width="130px">
                <template slot-scope="scope">
                  <div class="action">
              <span @click="handleEdits(scope.$index, scope.row)">
              <img src="../assets/image/edit@2x.png" alt="">
              </span>
                    <span @click="handleDelete(scope.$index, scope.row)">
              <img src="../assets/image/delete@2x.png" alt="">
              </span>
                    <span @click="handleReset(scope.$index, scope.row)">
              <img src="../assets/image/reset.png" alt="">
              </span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div v-else class="empty">
              <div>
                <img src="../assets/image/list_blank.png" alt="">
                <h2 style="color: #CCCCCC;font-size: 16px">No items found</h2>
              </div>
            </div>
          </div>
          <div class="btomPagin">
            <div class="innerLeft">{{ innerPage }} - <span>{{ innerTabel.length }}</span> of <span>{{ innerTotal }}</span>
              items
            </div>
            <div>
              <el-pagination
                :page-size="10"
                layout="prev, pager, next, jumper"
                :total="innerTotal"
                @current-change="handleCurrentChanges"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--    inbox 模块-->
    <div v-if="!out_box">
      <inbox @back="out_box = true"></inbox>
    </div>
    <!--    add and edit new organizations-->
    <el-dialog
      :close-on-click-modal="false"
      custom-class="noRadio"
      fullscreen
      :visible.sync="addNewOraDiog"
      @close="closeAddOrgHandle"
    >
      <addOrganization @closeAdd="closeAddHandle"
                       :editInfo="editInfo"
                       ref="addOrg"
                       :key="orgTime"
      ></addOrganization>
    </el-dialog>
    <!--    delete-->
    <el-dialog
      :close-on-click-modal="false"
      style="padding-top: 0"
      :title="deleteTitle"
      :visible.sync="deleteDialog"
      width="35%">
      <div class="addInner" v-if="oraDelete == 1" style="margin-top: 24px">
        Organization {{ oraMess }} will be permanently deleted. All accounts of this organization would not be used.
      </div>

      <div class="addInner" v-if="oraDelete == 2" style="margin-top: 24px">
        {{ storeMess }} will be permanently deleted. This account would not be used.
      </div>
      <span slot="footer" class="dialog-footer">
         <el-button type="danger" @click="deleteDialog = false" plain>Cancel</el-button>
    <el-button type="primary" @click="confirmDelete" round>Delete</el-button>
  </span>
    </el-dialog>
    <!--    重置密码-->
    <el-dialog
      :close-on-click-modal="false"
      style="padding-top: 0"
      title="Reset Password"
      :visible.sync="resetDialog"
      width="30%">
      <div class="addInner">
        <el-form :model="resetPass" label-position="top" :rules="resetRules" ref="restForm" status-icon
                 :show-message="false">
          <div>
            <el-form-item label="New Password" label-width="120px" prop="newPassword">
              <el-input v-model="resetPass.newPassword" placeholder="New Password" autocomplete="off">
              </el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
         <el-button type="danger" @click="cancelPass" plain>Cancel</el-button>
    <el-button type="primary" round @click="saveRest">Save</el-button>
      </span>
    </el-dialog>
    <!--   邀请-->
    <el-dialog
      :close-on-click-modal="false"
      style="padding-top: 0"
      title="Invite to join Rapidi"
      :visible.sync="inviteDialog"
      width="30%">
      <div class="addInner">
        <el-form :model="inviteForm" label-position="top" status-icon
                 :show-message="false">
          <div>
            <el-form-item label="Copy and share this link to invite new organization." label-width="120px">
              <div class="copy_box">
                <div>
                  You're invited to join Rapidi. Follow this link to join:
                </div>
                <el-tooltip placement="top" effect="dark" :content="copyText">
                  <span class="ellipsis" style="display:inline-block;">{{copyText}}</span>
                </el-tooltip>
              </div>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button type="success" round v-clipboard:copy="copyText" v-clipboard:success="copyTextHandle">Copy</el-button>
      </span>
    </el-dialog>
    <!--  组织详情-->
    <el-dialog
      :close-on-click-modal="false"
      custom-class="right"
      title="Organization Detail"
      :visible.sync="orgDetialDialog"
      width="30%">
      <organizationDetial @openDetial="openDetialHandle"
                          :orgDetial="orgDetial"
                          @openDelete="openDeleteHandle"
                          :key="orgDetialTime"
      ></organizationDetial>
    </el-dialog>
    <!--    新增店铺-->
    <el-dialog
      :close-on-click-modal="false"
      custom-class="noRadio"
      fullscreen
      :visible.sync="addNewStoreDiog"
      @close="closeStoreHandle"
    >
      <addNewStore @closeAddStore = 'closeAddStoreHandle'
                   :orgInfo = 'id'
                   :editMes = "editMes"
                   :key="storeTime"
                   ref="storeAdd"
      ></addNewStore>
    </el-dialog>
  </div>
</template>

<script>
import {
  deleteOra,
  deleteSubData,
  getOraList,
  getStoreList, inviteLink, resetPassword
} from "@/api/organization";
import {getGroupList} from "@/api/driver";
import addOrganization from "@/components/addOrganization";
import organizationDetial from "@/components/organizationDetial";
import inbox from "@/components/inbox";
import addNewStore from "@/components/addNewStore";
import {getInboxList} from "@/api/inbox";

export default {
  name: "organization",
  components: {
    addOrganization,organizationDetial,inbox,addNewStore
  },
  data() {
    return {
      storeTime:'',
      orgDetialTime:'',//进入新增/编辑org详情组件时得key 用来重新加载组件
      orgDetial:"",//组织详情
      orgTime:"",//进入新增/编辑org组件时得key 用来重新加载组件
      editInfo:'',//编辑组织时 携带的内容
      editMes:'',//编辑店铺时 携带的内容
      orgInfo:'',//新建店铺时 组织信息
      addNewStoreDiog:false,
      out_box:true,
      copyText:'',
      inviteForm:{
        mes:""
      },
      orgDetialDialog:false,
      inviteDialog:false,
      addNewOraDiog:false,
      inbox_num: 1,
      resetId: '',
      resetPass: {
        newPassword: ''
      },
      resetDialog: false,
      storeId: '',
      id: '',
      oraId: '',
      oraLoading: false,
      storeLoading: false,
      oraMess: '',
      oraDelete: '',
      storeMess: '',
      deleteDialog: false,
      deleteTitle: '',
      options: [],
      resetRules: {
        newPassword: [
          {required: true, message: '', trigger: 'blur'},
        ],
      },
      rules: {
        name: [
          {required: true, message: '', trigger: 'blur'},
        ],
      },
      out: true,
      page: 1,
      total: 0,
      organData: [],
      innerTitle: '',
      innerTabel: [],
      outPage: 1,
      outTotal: 0,
      innerTotal:0,//store total
      innerPage:1,//store page
      admin:'',//用来判断当前用户类型
    }
  },
  created() {
    this.getListData()
    this.getDriverGroup()
    this.getInboxList()
    const userInfo = localStorage.getItem('userInfo')
    if (userInfo) {
      this.admin = JSON.parse(userInfo).type
    }  },
  methods: {
    handleOrgCurrentChange(val){
      this.outPage = val
      this.getListData()
    },
    //获取审核列表 将总数回显 inbox_num
    getInboxList(){
      getInboxList({
        page:1,
        limit:10
      }).then(res=>{
        this.inbox_num = res.data.count
      })
    },
    closeStoreHandle(){
      this.editMes =''
      this.$refs.storeAdd.clearTheForm()
    },
    closeAddStoreHandle(){
      this.getStoreData(this.id)
      this.addNewStoreDiog = false
    },
    //关闭新增组织弹框 并且刷新列表
    closeAddHandle(){
      this.addNewOraDiog =false
      this.getListData()
    },
    //在弹框关闭时 触发，清空表单
    closeAddOrgHandle(){
      this.editInfo = ''
      this.$refs.addOrg.clearTheForm()
    },
    //打开邀请弹框
    InviteHandle(){
      inviteLink().then(res=>{
        if (res.code == 200){
          this.copyText = res.data
          this.inviteDialog = true
        }else {
          this.$message({
            type:"error",
            message:res.msg
          })
        }
      })
    },
    //复制邀请连接
    copyTextHandle(){
      this.$message({
        type:"success",
        message:'copy successfully'
      })
    },
    openInboxHandle(){
      this.out_box = false
    },
    validateForms() {
      let flag = false
      this.$refs['restForm'].validate((valid) => {
        flag = valid
      })
      return flag
    },
    //新增店铺
    addSubHandle(){
      this.storeTime = new Date().getTime()
      this.addNewStoreDiog = true
    },
    //关闭重置密码弹框
    cancelPass() {
      this.resetDialog = false
      // this.resetPass.newPassword = ''
      this.$refs['restForm'].resetFields()
    },

    //重置密码
    handleReset(index, row) {
      this.resetDialog = true
      this.resetId = row.id
    },
    saveRest() {
      this.validateForms()
      if (this.validateForms()) {
        resetPassword({
          id: this.resetId,
          new_password: this.resetPass.newPassword
        }).then(res => {
          if (res.code == 200) {
            this.resetDialog = false
            this.$message({
              type: "success",
              message: 'Password has been reset'
            })
          } else {
            this.$message({
              type: "error",
              message: res.msg
            })
          }
        })
      }
    },
    //获取司机 group
    getDriverGroup() {
      getGroupList({
        page: this.page1,
        limit: '',
      }).then(res => {
        this.groupLoading = false
        if (res.code == 200) {
          this.options = res.data.data
        } else {
          // this.$message({
          //   message:res.mag,
          //   type:'warning'
          // })
        }
      }).catch(err => {
        this.$message({
          message: err.mag,
          type: 'error'
        })
      })
    },
    showPassError() {

    },
    //新建sub store
    getStoreData(id) {
      this.storeLoading = true
      getStoreList({
        id: id,
        page: this.innerPage,
        limit: 10
      }).then(res => {
        this.storeLoading = false
        if (res.code == 200) {
          this.innerTotal = res.data.count
          this.innerTabel = res.data.data
        }
      })
    },
    getListData() {
      this.oraLoading = true
      getOraList({
        page: this.outPage,
        limit: 10,
        order: 'time desc'
      }).then(res => {
        this.oraLoading = false
        this.organData = res.data.data
        this.outTotal = res.data.count

      })
    },
    handleCurrentChange(val) {
      this.outPage = val
      this.getListData()
    },
    handleCurrentChanges(val) {
      this.innerPage = val
      this.getStoreData(this.id)
    },
    handleEdit(index, row) {
      this.editInfo = row
      this.orgTime  = new Date().getTime()
      this.addNewOraDiog = true
    },
    //organization detial
    handleDetial(index, row) {
      this.orgDetial = row
      this.orgDetialTime = new Date().getTime()
      this.orgDetialDialog = true
    },
    //编辑店铺
    handleEdits(index,row){
      this.editMes = row
      this.storeTime = new Date().getTime()
      this.addNewStoreDiog = true
    },
    openDetialHandle(a){
      // console.log(a,'aaaaaaaaaa')
      this.editInfo = a
      this.addNewOraDiog = true
    },
    openDeleteHandle(a){
      this.deleteDialog = true
      this.oraMess = a.organization_name
      this.oraId = a.id
      this.oraDelete = 1
      this.deleteTitle = 'Delete Organization'
    },
    handleDelete(index, row) {
      this.deleteDialog = true
      if (row.organization_name) {
        this.oraMess = row.organization_name
        this.oraId = row.id
        this.oraDelete = 1
        this.deleteTitle = 'Delete Organization'
      } else {
        this.storeMess = row.sub_organization_name
        this.oraDelete = 2
        this.storeId = row.id
        this.deleteTitle = 'Delete Sub Store'
      }
    },
    changeTable(row) {
      this.out = false
      this.innerTitle = row.organization_name
      this.storeLoading = true
      this.id = row.id
      this.getStoreData(row.id)
    },
    //确认删除
    confirmDelete() {
      if (this.oraDelete == 1) {
        deleteOra({
          id: this.oraId
        }).then(res => {
          this.deleteDialog = false
          this.orgDetialDialog = false
          if (res.code == 200) {
            this.outPage = 1
            this.getListData()
            this.$message({
              type: 'success',
              message: res.msg
            })
          }
        })
      } else if (this.oraDelete == 2) {
        deleteSubData({
          id: this.storeId
        }).then(res => {
          this.deleteDialog = false
          if (res.code == 200) {
            this.innerPage = 1
            this.getStoreData(this.id)
            this.$message({
              type: 'success',
              message: res.msg
            })
          }else {
            this.$message({
              type:"warning",
              message:res.msg
            })
          }
        }).catch(err=>{
          this.$message({
            type:"error",
            message:err.msg
          })
        })
      }
    }
  }
}
</script>

<style scoped lang="less">
.organization {
  /deep/ .changePadding {
    padding-left: 48px;
  }

  .inbox_box {
    display: inline-block;
    text-align: right;
    margin-right: 16px;
    cursor: pointer;
  }

  .tabel {
    margin-top: 16px;

    .action {
      span {
        cursor: pointer;
      }

      img {
        width: 16px;
        margin-right: 16px;
      }
    }

  }

  .empty {
    width: 200px;
    height: 387px;
    margin: 20px auto;
    text-align: center;
    position: relative;

    div {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }

    h2 {
      font-size: 16px;
    }

    img {
      width: 100%;
      height: 200px;
      margin: 0;
    }
  }

  .btomPagin {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    padding-left: 16px;

    .innerLeft {
      font-size: 16px;
      font-family: SFPro-Regular, SFPro;
      font-weight: 400;
      color: #1F2D42;
      line-height: 20px;
    }
  }

  .backBox {
    display: flex;
    font-weight: normal;

    .innerLeft {
      margin-right: 20px;
      cursor: pointer;
    }
  }

  .addInner {
    font-weight: normal;
    font-size: 14px;
    color: #1F2D42;
    line-height: 20px;
    word-wrap: break-word;
    .copy_box{
      border-radius: 16px;
      border: 1px solid #E0E0E0;
      padding: 8px 16px;
    }
    .btomSuffix {
      /deep/ .el-input__prefix {
        margin-left: 12px;
        color: #1F2D42;
      }

      ///deep/.el-input__inner{
      //  border-left: none;
      //}
      ///deep/.el-input-group__prepend{
      //  background: none;
      //  padding: 0 8px 0 12px;
      //}
    }
  }
}
</style>
